import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface FloatingMenuOption {
    id: string;
    text: string;
    action?: any;
}

export interface FloatingMenuPosition {
    top: number;
    left: number;
}

/** This component displays a floating menu */
@Component({
    selector: 'cw-floating-menu',
    templateUrl: './floating-menu.component.html',
    styleUrls: ['./floating-menu.component.scss'],
    standalone: false,
})
export class FloatingMenuComponent {
    /** Options to show in menu */
    @Input() options!: FloatingMenuOption[];

    /** Position where to display the menu*/
    @Input() position: FloatingMenuPosition = { top: 0, left: 0 };

    /** Event emitted when clicking on an option */
    @Output() clickOption: EventEmitter<FloatingMenuOption> = new EventEmitter();

    /** Event emitted when clicking the close button */
    @Output() clickClose: EventEmitter<void> = new EventEmitter();

    /**
     * Emits clickOption event when clicking in an option
     */
    onClickOption(option: FloatingMenuOption): void {
        this.clickOption.emit(option);
    }

    /**
     * Emits clickClose event when clicking in close button
     */
    onClickClose(): void {
        this.clickClose.emit();
    }
}
